<template>
	<div class="wrapBox">
		<navheader current="0"></navheader>
		<!-- 抡博图 -->
		<div class="bannerImg">
			<div class="lunboImg">
				<el-carousel indicator-position="inside" height="36rem">
				    <el-carousel-item v-for="(item,index) in bannerlist" :key="index">
						<div class="carousel-img-container">
							<img :src="item.url" class="carousel-img">
						</div>
				    </el-carousel-item>
				</el-carousel>
			</div>
			<!-- <div class="bannerText" style="width: 24rem; height: 29rem;">
				<img src="../assets/images/bennertext.png" alt="" width="100%" height="100%">
			</div> -->
		</div>
		<div class="smallbannerImg">
			<div class="lunboImg">
				<el-carousel indicator-position="inside" height="200px">
				    <el-carousel-item v-for="(item,index) in bannerlist" :key="index">
						<img :src="item.url" style="width: 100%;height: 100%;">
				    </el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 医院介绍 -->
		<div class="hospitalDes">
			<div class="commonBox">
				<div class="commonTitle">上实东滩疗养院</div>
				<div class="commonSubTitle">疗养院介绍</div>
			</div>
			<div class="hospitalctx">
				<p>上实东滩疗养院，是由上实集团旗下骨干企业联合投资建设，并与上海市保健医疗中心（华东疗养院）强强联手，共同打造的高端医疗康养机构。 在上海的“后花园”——崇明东滩，广袤湿地与江海交汇，风景如诗如画，生机勃勃。这里是大自然赐予的疗愈圣地，也是上实东滩疗养院为您打造的理想栖息之所。这里蕴含着独特的魅力——湿地的生态纯净与疗愈的深远力量。它以自然为载体，让每一位来访者在宁静与美丽的环境中，找回最本真的自己，体验从心灵到身体的深度疗愈。</p>
				<p></p>
			</div>
			<!-- <div class="hospitalslogn">
				<div class="slogn" v-for="(item,index) in slognList" :key="index">
					<div class="id">{{item.id}}</div>
					<div class="name">{{item.name}}</div>
					<div v-html="item.title"></div>
				</div>
			</div> -->
		</div>
		<div>
		<!-- 视频展示 -->
		 <!-- <div class="commonStyle">
			<div style="display: flex;justify-content: center;padding-bottom: 6.25rem;width: 80rem;margin: 0 auto;">
				<video src="../assets/images/video.mp4" controls autoplay loop muted style="width: 100%;height: 100%;object-fit: contain;"></video>
			</div>
		 </div>
		 <div class="smallStyle">
			<div style="display: flex;justify-content: center;">
				<video src="../assets/images/video.mp4" controls autoplay loop muted style="width: 100%;height: 100%;object-fit: contain;"></video>
			</div>
		 </div> -->
		</div>
		<!-- 我们的理念 -->
		<div class="OurPhilosophy">
			<div class="commonBox">
				<div class="commonTitle">品牌理念</div>
				<div class="commonSubTitle">颐养致远，积健至上</div>
			</div>
			<div class="hospitalctx">
				<p>秉承着“颐养致远，积健至上”的品牌理念，依托世界级湿地修复成果与丰富的生态资源，立足自然，汇聚尖端医学，致力于为您提供全面、个性化的康养体验。无论是为慢病调理、亚健康管理，还是身体恢复与精神养护，我们都能够为每位来访者量身定制最贴心的健康服务。在这里，您不仅能够享受先进的医疗技术和高端设施，更能沉浸于大自然的怀抱中，获得身心的深度疗愈。</p>
			</div>
			<!-- <div class="PhilosophySlogn">
				<div class="slogn" v-for="(item,index) in PhilosophySlognList">
					<img :src="item.id" alt="" class="imgsize">
					<div class="name">{{item.name}}</div>
					<div class="subtitle">{{item.title}}</div>
				</div>
			</div> -->
		</div>
		<div class="hospitalDes paddingStyle">
			 <div class="commonBox">
			 	<div class="commonTitle">康养环境</div>
				
				<div class="commonStyle" style="padding:0 5rem">
					<el-row :gutter="20">
						<el-col :span="8" v-for="(item,index) in kylist" :key="index">
							<img :src="item.url"  height="100%" width="100%" style="margin-top: 3.25rem;">
						</el-col>
					</el-row>
					<!-- <div  style="display: flex;justify-content: center;">
						<el-carousel :interval="4000" type="card" height="26.875rem" width="80%" style="margin-top: 3.25rem;" indicator-position="none" cursor="none" arrow="never">
							<el-carousel-item v-for="(item,index) in kylist" :key="index" >
								<div style="position: relative;border-radius: 1.25rem;height: 26.875rem;">
									<img :src="item.url"  height="100%" width="100%">
									<span class="luboSpan">{{item.name}}</span>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div> -->
				</div>
				<div class="smallStyle">
					<el-row :gutter="5">
						<el-col :span="8" v-for="(item,index) in kylist" :key="index">
							<img :src="item.url"  height="100%" width="100%" style="margin-top: 3.25rem;">
						</el-col>
					</el-row>
					<!-- <div  style="display: flex;justify-content: center;">
						<el-carousel :interval="4000" type="card" height="130px" width="80%" style="margin-top: 10px;" indicator-position="none" cursor="none" arrow="never">
							<el-carousel-item v-for="(item,index) in kylist" :key="index" >
								<div style="position: relative;border-radius: 20px;">
									<img :src="item.url"  height="130px">
									<span class="luboSpan">{{item.name}}</span>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div> -->
				</div>
				
			 </div>
		</div>
		<!-- <div class="OurPhilosophy paddingStyle" style="background-color: #fff;background-image: none;">
			<div class="commonBox">
				<div class="commonTitle">DNA甲基化检测和基因检测</div>
				<div class="commonSubTitle">基于年龄的精准常规体检项目系统</div>
			</div>
			<div class="jyjcSlogn">
				<img src="../assets/images/jyjc.png" alt="" class="imgsize">
				<div class="commonStyle">
					<div class="SlognText" v-for="(item,index) in jyjcList" :style="{left:item.left,top:item.top,right:item.right}">
						<div class="id">{{item.id}}</div>
						<div class="name">{{item.name}}</div>
					</div>
				</div>
				<div class="smallStyle">
					<div class="SlognText" v-for="(item,index) in jyjcList1" :style="{left:item.left,top:item.top,right:item.right}">
						<div class="id">{{item.id}}</div>
						<div class="name">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="hospitalDes paddingStyle" >
			 <div class="commonBox">
			 	<div class="commonTitle">五“康”之旅：为您的健康护航</div>
				<div class="commonSubTitle">健康管理五大体系</div>
			 </div>
			 <div class="fiveSlogn">
				 <div><span>康检 · 未病先防的起点</span><span>康养 · 自然与生命的对话</span><span>康旅 · 健康也是一场旅行</span></div>
				 <div class="secondBox"><span>康复 · 科学干预的力量</span><span>康健 · 一生相伴的守护</span></div>
			 </div>
		</div>
		<div class="hospitalDes paddingStyle">
			<div class="commonBox">
			 	<div class="commonTitle">特色功能中心</div>
				<div class="commonSubTitle">多维康养体系让健康可控可预见</div>
			</div>
			<div class="hospitalctx widthpadding">
				<p>秉承着“颐养致远，积健至上”的品牌理念，依托世界级湿地修复成果与丰富的生态资源，立足自然，汇聚尖端医学，致力于为您提供全面、个性化的康养体验。无论是为慢病调理、亚健康管理，还是身体恢复与精神养护，我们都能够为每位来访者量身定制最贴心的健康服务。在这里，您不仅能够享受先进的医疗技术和高端设施，更能沉浸于大自然的怀抱中，获得身心的深度疗愈。</p>
			</div>
			<div class="tsSlogn">
				
				<div class="slogn" v-for="(item,index) in tsList">
					<img :src="item.id" alt="" class="imgsize" >
					<div class="name">{{item.name}}</div>
					<div class="subtitle">{{item.title}}</div>
				</div>
			</div>
		</div>
		<footercommon></footercommon>
	</div>

</template>	
<script>
import navheader from "../components/navheader.vue";
import footercommon from "../components/footercommon.vue";
import swipt from "../components/swipt.vue";
import { GetImg } from "@/api/api";
export default {
  components: { navheader,footercommon, swipt},
  data() {
    return {
		slognList:[
			{id:"01",name:'宗旨',title:'高技术体检中心<br>高水平诊疗中心<br>高品质康养中心<br>'},
			{id:"02",name:'定位',title:'高技术体检中心<br>高水平诊疗中心<br>高品质康养中心<br>'},
			{id:"03",name:'愿景',title:'高技术体检中心<br>高水平诊疗中心<br>高品质康养中心<br>'}
		],
		PhilosophySlognList:[
			{id:require('../assets/images/ln3.png'),name:'绿色',title:'GREEN'},
			{id:require('../assets/images/ln2.png'),name:'健康',title:'HEALTH'},
			{id:require('../assets/images/ln4.png'),name:'融合',title:'FUSION'},
			{id:require('../assets/images/ln1.png'),name:'创新',title:'INNOVATION'}
		],
		isMobile: false,
		tsList:[
			{id:require('../assets/images/ts1.png'),name:'健康评估',title:'健康体检中心，医学检验中心'},
			{id:require('../assets/images/ts2.png'),name:'疾病筛查',title:'医学影像中心，消化内镜中心'},
			{id:require('../assets/images/ts3.png'),name:'健康干预',title:'慢病管理中心，康复理疗中心，高压氧疗中心'}
		],
		jyjcList:[
			{id:"01",name:'发现早期隐患',left:'10.25rem',top:'25rem'},
			{id:"02",name:'自动智能分析',left:'19.625rem',top:'10.5rem'},
			{id:"03",name:'监测数据准确',left:'45%',top:'0'},
			{id:"04",name:'360度全面检测',right:'19.875rem',top:'10.5rem'},
			{id:"05",name:'360度全面检测',right:'10.25rem',top:'25rem'}
		],
		jyjcList1:[
			{id:"01",name:'发现早期隐患',left:'10%',top:'60%'},
			{id:"02",name:'自动智能分析',left:'20%',top:'30%'},
			{id:"03",name:'监测数据准确',left:'45%',top:'0'},
			{id:"04",name:'360度全面检测',right:'10%',top:'30%'},
			{id:"05",name:'360度全面检测',right:'5%',top:'60%'}
		],
		kylist:[],
		bannerlist:[],
    };
  },
  mounted() {
    this.getImg();
  },
  methods: {
	getImg() {
	  GetImg({status:1}).then(res => {
		  this.kylist=[]
	  	res.data.data.rows.forEach((item,index)=>{
	  		if(item.codeDesc=='康养环境'){
	  			this.kylist.push({
	  				id:index,
	  				url:item.adImgPath,
					name:item.adName
	  			})
	  		}
			if(item.codeDesc=='banner'){
				this.bannerlist.push({
					id:index,
					url:item.adImgPath,
				})
			}
	  	})
			console.log(this.kylist,'333')
	  })
	},
  },
};
</script>
<style lang="scss" scoped>
.bannerImg{
	background-color:$baseColor ;
	color:#fff;
	position: relative;
	.lunboImg{
		height: 36rem;
		// width:80rem;
		width:100%;
		overflow: hidden;
	}
	.bannerText{
		position: absolute;
		left:85rem;
		top:3rem;
	}
}
.hospitalctx{
		color:$fintColor;
		line-height: 2.5rem;
		margin-top: 3.75rem;
		font-size: 1.375rem;
		text-align: justify;
	}
.hospitalDes{
	font-size: 1.375rem;
	padding:6.25rem;
	.hospitalctx{
		color:$fintColor;
		line-height: 2.5rem;
		margin-top: 3.75rem;
	}
	.hospitalslogn{
		margin-top: 6.25rem;
		display: flex;
		color:$fintColor;
		font-size: 1.5rem;
		justify-content: space-between;
		padding:0 10rem;
		.slogn{
			width: 18.75rem;
			text-align: center;
			.id{
				color:$baseColor;
				font-weight: 800;
				font-size: 2.625rem;
			}
			.name{
				font-weight: 800;
				margin-bottom: 2.5rem;
			}
		}
	}
}
.OurPhilosophy{
	// background-color: #f7f7f7;
	padding:0rem  6.25rem 6.25rem 6.25rem;
	// background-image: url('../assets/images/lnbg.png');
	background-repeat: no-repeat;
	background-size: 100%;
	.PhilosophySlogn{
		margin-top: 3.5rem;
		display: flex;
		justify-content: space-between;
		.imgsize{
			width: 8rem;
			height: 8rem;
		}
		.slogn{
			width: 22%;
			height: 21.1875rem;
			text-align: center;
			background-color: #fff;
			border-radius: 1.6875rem;
			padding:2.5rem 0;
			box-sizing: border-box;
			.name{
				margin-top: 1.6875rem;
				font-weight: 800;
				margin-bottom: 0.375rem;
				font-size: 2.25rem;
				color: $baseColor;
			}
			.subtitle{
				font-size: 1.5rem;
				color:$fintColor;    
				font-weight: 700;
			}
		}
	}
}
.tsSlogn{
		margin-top: 3.5rem;
		display: flex;
		justify-content: space-between;
		padding:0 10rem;
		.imgsize{
			width: 6.25rem;
			height: 6.25rem;
		}
		.slogn{
			width: 32%;
			text-align: center;
			background-color: #fff;
			border-radius: 1.25rem;
			padding:4.75rem 3.125rem 5.625rem 3.125rem;
			box-sizing: border-box;
			background: #F7F7F7;
			.name{
				margin-top: 1.6875rem;
				font-weight: 800;
				margin-bottom: 0.375rem;
				font-size: 2.25rem;
				color: $fintColor;
			}
			.subtitle{
				font-size: 1.375rem;
				color:$fintColor;  
			}
		}
}
.fiveSlogn{
	margin-top: 7.5rem;
	padding:0 12rem;
	div{
		display: flex;
		margin-bottom: 6.25rem;
		justify-content: space-between;
		span{
			display: inline-block;
			width: 28rem;
			line-height: 7.875rem;
			border-radius:0 7.875rem 7.875rem 7.875rem;
			text-align: center;
			background: $baseColor;
			font-size: 2rem;
			color:#fff;
			box-shadow: inset -0.25rem -0.25rem 0.65rem 0px rgba(0, 0, 0, 0.11),inset 0.3125rem 0.3125rem 0.3375rem 0px rgba(255, 255, 255, 0.38);
			
		}
	}
	.secondBox{
		display: flex;
		justify-content: space-around;
		padding:0 9.375rem;
	}
}
.jyjcSlogn{
	background-image: url('../assets/images/bg.png');
	background-repeat: no-repeat;
	background-size: 100%;
	margin-top: 3.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	box-sizing: border-box;
	.imgsize{
		width: 50rem;
		height: 45rem;
		margin-top: 1.25rem;
	}
	.SlognText{
		position: absolute;
		.id{
			color:$baseColor;
			font-weight: 800;
			font-size: 4rem;
		}
		.name{
			font-size: 2.25rem;
		}
	}
}
::v-deep.el-carousel.el-carousel--horizontal.el-carousel--card{
	width: 90rem;
}
::v-deep.el-carousel__item.el-carousel__item--card.is-in-stage{
	border-radius: 1.25rem;
}

  .luboSpan{
	  position: absolute;
	  right: 0;
	  top: 0;
	  display: inline-block;
	 background: rgba(13, 31, 29, 0.67);
	 width: 8.6875rem;
	 line-height: 3.3125rem;
	 color:#fff;
	 border-radius: 0px 1.25rem 0px 1.25rem;
  }
// 本页公共样式
.commonBox{
	color:$baseColor;
	text-align: center;
	.commonTitle{
		font-size: 2.625rem;
		margin-bottom: 0.625rem;
		font-weight: 800;
	}
	.commonSubTitle{
		color:#3B5B59 ;
		font-size: 1.375rem;
	}
	
}
.paddingStyle{
	padding:3.25rem 0;
}
.widthpadding{
	padding:0 6.25rem
}
@media screen and (min-width: 769px) {//pc版本
		.smallbannerImg{display: none;}
		.smallStyle{display: none;}
	}
@media screen and (max-width: 768px) {//手机版本
	.commonStyle{display: none;}
	.bannerImg{display: none;}
	.widthpadding{
		padding:0 10px;
	}
	.smallbannerImg{
		background-color:$baseColor ;
		color:#fff;
		.lunboImg{
			height: 12.5rem;
			width:100%;
			overflow: hidden;
		}
		
	}
	.commonBox{
		color:$baseColor;
		text-align: center;
		.commonTitle{
		font-size: 22px;
		}
		.commonSubTitle{
			font-size: 12px;
		}
	}
	.hospitalctx{
		line-height: 20px;
		margin-top: 20px;
		font-size: 12px;
	}
	.hospitalDes{
		font-size: 12px;
		padding:40px 10px;
		.hospitalctx{
			line-height: 20px;
			margin-top: 20px;
		}
		.hospitalslogn{
			margin-top: 40px;
			font-size: 12px;
			padding:0;
			.slogn{
				width: 33%;
				text-align: center;
				.id{
					font-size: 32px;
				}
				.name{
					margin-bottom: 20px;
				}
			}
		}	
		
	}
	.OurPhilosophy{
		padding:20px 10px;
		// background-image: url('../assets/images/lnbg.png');
		background-repeat: no-repeat;
		background-size: 100%;
		background-color: transparent;
		.PhilosophySlogn{
			margin-top: 40px;
			display: flex;
			justify-content: space-between;
			.imgsize{
				width: 48px;
				height: 48px;
			}
			.slogn{
				width: 24%;
				height: 139px;
				text-align: center;
				background-color: #fff;
				border-radius: 10px;
				padding:10px 0;
				box-sizing: border-box;
				.name{
					margin-top: 10px;
					font-weight: 800;
					margin-bottom: 6px;
					font-size: 16px;
				}
				.subtitle{
					font-size: 12px;
					font-weight: 700;
				}
			}
		}
	}
	.paddingStyle{
		padding:20px 0 ;
	}
	.luboSpan{
		position: absolute;
	  	right: 0;
	  	top: 0;
	  	display: inline-block;
	 	background: rgba(13, 31, 29, 0.67);
		width: 69px;
		line-height: 33px;
		color:#fff;
		border-radius: 0px 10px 0px 10px;
	}
	.jyjcSlogn{
		margin-top: 40px;
		.imgsize{
			width: 200px;
			height: 160px;
		}
		.SlognText{
			position: absolute;
			.id{
				color:$baseColor;
				font-weight: 800;
				font-size: 24px;
			}
			.name{
				font-size: 12px;
			}
		}
	}
	.fiveSlogn{
		margin-top: 40px;
		padding:0 10px;
		div{
			display: flex;
			margin-bottom: 10px;
			justify-content: space-between;
			span{
				display: inline-block;
				width: 200px;
				line-height: 46px;
				border-radius:0 126px 126px 126px;
				text-align: center;
				background: $baseColor;
				font-size: 10px;
				color:#fff;
				box-shadow: inset -4px -4px 10.4px 0px rgba(0, 0, 0, 0.11),inset 5px 5px 5.4px 0px rgba(255, 255, 255, 0.38);
				
			}
		}
		.secondBox{
			display: flex;
			justify-content: space-around;
			padding:0 40px;
		}
	}
	.tsSlogn{
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		padding:0 10px;
		.imgsize{
			width: 40px;
			height: 40px;
		}
		.slogn{
			padding:10px 4px;
			.name{
				font-size: 16px;
				margin-top: 0px;
			}
			.subtitle{
				font-size: 10px;
			}
		}
	}
}

::v-deep .el-carousel__item--card.is-in-stage{
	cursor: auto;
}

.carousel-img-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: #000; // 可选：添加背景色
}

.carousel-img {
    width: 100%;
    height: 100%;
    object-fit: cover; // 保持图片比例，裁剪多余部分
    object-position: center; // 图片居中显示
}

</style>
